module.exports = "https://ssr-releases-cdn.paperlesspost.com/_next/static/images/tile_bachelorette-d7b4c243706e237e4e399040056f773c.jpg";